// extracted by mini-css-extract-plugin
export default {"tdFonte1":"ClienteVersoes_tdFonte1__V081I","tdFonte2":"ClienteVersoes_tdFonte2__7DIVZ"};